import React from 'react';
import styles from './RoleManagement.module.css';
import LoadingContainer from '../../components/Common/LoadingContainer';

const RoleTable = ({ roles, onEdit, onDelete, onHistory, loading }) => {
    if (loading) {
        return <LoadingContainer message="Loading roles..." />;
    }

    return (
        <div className={styles.tableWrapper}>
            <table className={styles.table}>
                <thead className={styles.tableHead}>
                    <tr>
                        <th>Role Name <button className={styles.sortButton}>↕</button></th>
                        <th>Status <button className={styles.sortButton}>↕</button></th>
                        <th className={styles.actionsColumn}>Actions</th>
                    </tr>
                </thead>
                <tbody className={styles.tableBody}>
                    {roles.length > 0 ? (
                        roles.map((role) => (
                            <tr key={role.id} className={styles.tableRow}>
                                <td>
                                    <div className={styles.roleCell}>
                                        <div className={styles.roleName}>{role.name}</div>
                                        {role.description && (
                                            <div className={styles.roleDescription}>{role.description}</div>
                                        )}
                                    </div>
                                </td>
                                <td>
                                    <span className={`${styles.statusBadge} ${role.status === 'Active' ? styles.statusActive : styles.statusInactive}`}>
                                        {role.status}
                                    </span>
                                </td>
                                <td>
                                    <div className={styles.actionIcons}>
                                        <button className={styles.iconButton} onClick={() => onEdit(role)} title="Edit">
                                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                                                <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
                                            </svg>
                                        </button>
                                        <button
                                            className={styles.iconButton}
                                            onClick={() => onDelete(role)}
                                            title="Delete"
                                            disabled={role.userCount > 0}
                                        >
                                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                <polyline points="3 6 5 6 21 6" />
                                                <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
                                            </svg>
                                        </button>
                                        <button className={styles.iconButton} onClick={() => onHistory(role)} title="History">
                                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                <circle cx="12" cy="12" r="10" />
                                                <polyline points="12 6 12 12 16 14" />
                                            </svg>
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan="3" className={styles.noData}>No roles found</td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    );
};

export default RoleTable;